export var PROFILE_STEP_TYPE;
(function (PROFILE_STEP_TYPE) {
    PROFILE_STEP_TYPE["NAME_AND_COUNTRY"] = "nameCountryStep";
    PROFILE_STEP_TYPE["EMAIL"] = "emailStep";
    PROFILE_STEP_TYPE["PASSWORD"] = "passwordStep";
    PROFILE_STEP_TYPE["CREATE_ACCOUNT"] = "createAccountStep";
    PROFILE_STEP_TYPE["BIRTHDAY"] = "birthdayStep";
    PROFILE_STEP_TYPE["RACE"] = "raceStep";
    PROFILE_STEP_TYPE["RACE_GENDER"] = "raceGenderStep";
    PROFILE_STEP_TYPE["LOCATION"] = "locationStep";
    PROFILE_STEP_TYPE["OCCUPATION"] = "occupationStep";
    PROFILE_STEP_TYPE["MARITAL_STATUS"] = "maritalStatusStep";
    PROFILE_STEP_TYPE["INCOME"] = "incomeStep";
    PROFILE_STEP_TYPE["SOCIAL_MEDIA"] = "socialMediaStep";
    PROFILE_STEP_TYPE["PROFESSION"] = "professionStep";
    PROFILE_STEP_TYPE["INTEREST"] = "interestStep";
    PROFILE_STEP_TYPE["COMPLETE"] = "completeStep";
    PROFILE_STEP_TYPE["REMINDER_PROFILE"] = "reminderProfileStep";
    PROFILE_STEP_TYPE["REMINDER_EMAIL"] = "reminderEmailStep";
    PROFILE_STEP_TYPE["PHONE"] = "phoneStep";
    PROFILE_STEP_TYPE["ADDRESS"] = "addressStep";
    PROFILE_STEP_TYPE["CREATE_ADDRESS"] = "createAddressStep";
    PROFILE_STEP_TYPE["COUNTRY"] = "countryStep";
})(PROFILE_STEP_TYPE || (PROFILE_STEP_TYPE = {}));
export var DEFAULT_COMPLETE_PROFILE_STEP_ORDER = [
    PROFILE_STEP_TYPE.CREATE_ACCOUNT,
    PROFILE_STEP_TYPE.BIRTHDAY,
    PROFILE_STEP_TYPE.RACE_GENDER,
    PROFILE_STEP_TYPE.LOCATION,
    PROFILE_STEP_TYPE.OCCUPATION,
    PROFILE_STEP_TYPE.MARITAL_STATUS,
    PROFILE_STEP_TYPE.INCOME,
    PROFILE_STEP_TYPE.SOCIAL_MEDIA,
    PROFILE_STEP_TYPE.INTEREST,
    PROFILE_STEP_TYPE.COMPLETE,
];
